import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { AgentCreate } from '@ragu-components/ord-types';

const AgentsList = React.lazy(async () => import('./AgentsList'));

export const agentsResource: OrdResourceProps = {
  key: Resources.agents,
  name: Resources.agents,
  list: <AgentsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (agent: AgentCreate): string => agent.name,
};
